// Copied from sitebuilder/js/src/sanitize.js — generated by sitebuilder/js/build.mjs, do not edit here.
// Richtext sanitizer for the editor, matching render/sanitize.go richtextPolicy (same tags, links only
// http(s)/mailto/tel/relative). Pass the window's DOMPurify (browser) or one bound to jsdom (tests).
// The result is serialized the way Go's bluemonday writes it (html.EscapeString: & < > " ' → &amp; &lt; &gt;
// &#34; &#39;), so the editor preview and the server render produce the same bytes.
export const RICHTEXT_TAGS = ['p', 'br', 'b', 'strong', 'i', 'em', 'u', 's', 'a', 'ul', 'ol', 'li', 'h3', 'h4', 'blockquote', 'code', 'mark', 'sub', 'sup', 'span']

const VOID = new Set(['br', 'hr', 'img'])
const esc = (s) => s.replace(/&/g, '&amp;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&#34;')

function serialize(node) {
  let out = ''
  for (const n of node.childNodes) {
    if (n.nodeType === 3) out += esc(n.data)
    else if (n.nodeType === 1) {
      const tag = n.tagName.toLowerCase()
      if (tag === 'a' && !n.hasAttribute('href')) { out += serialize(n); continue } // bluemonday drops the bare <a>
      out += '<' + tag
      // DOMPurify re-adds kept attributes last-to-first: reverse to get the source order bluemonday keeps;
      // bluemonday adds rel on target=_blank (noreferrer too for absolute URLs)
      const attrs = [...n.attributes].map((a) => [a.name, a.value]).reverse()
      if (tag === 'a' && n.getAttribute('target') === '_blank') {
        attrs.push(['rel', /^([a-z][a-z0-9+.-]*:|\/\/)/i.test(n.getAttribute('href') || '') ? 'noreferrer noopener' : 'noopener'])
      }
      for (const [k, v] of attrs) out += ` ${k}="${esc(v)}"`
      out += '>'
      if (!VOID.has(tag)) out += serialize(n) + `</${tag}>`
    }
  }
  return out
}

export function richtextSanitizer(DOMPurify) {
  return (html) => serialize(DOMPurify.sanitize(html, {
    ALLOWED_TAGS: RICHTEXT_TAGS,
    ALLOWED_ATTR: ['href', 'target'],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
    RETURN_DOM_FRAGMENT: true,
  }))
}
